// Appearance, per device: Blackberry dark by default, Navy light by choice, Full black only in the phone app (OLED).
// index.html applies the saved choice before the first paint; this module changes it.
import { Native } from "./native";

export type Theme = "dark" | "light" | "black";
export const THEME_NAME: Record<Theme, string> = { dark: "Blackberry dark", light: "Navy light", black: "Full black" };
const KEY = "compass-theme";
const BAR: Record<Theme, string> = { dark: "#160d1c", light: "#0b2542", black: "#000000" }; // browser toolbar, matches --nav

export const themes = (): Theme[] => (Native ? ["dark", "light", "black"] : ["dark", "light"]);

export function getTheme(): Theme {
  let t: string | null = null;
  try { t = localStorage.getItem(KEY); } catch { /* storage blocked: default */ }
  return themes().includes(t as Theme) ? (t as Theme) : "dark";
}

export function setTheme(t: Theme) {
  try { localStorage.setItem(KEY, t); } catch { /* still applies for this visit */ }
  const root = document.documentElement;
  if (t === "dark") delete root.dataset.theme; else root.dataset.theme = t;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", BAR[t]);
}
